module.exports = __webpack_public_path__ + "media/images/iconTrendUp__errorRed--dark-c5d090513fea424dbe7bd09ccbbbd4a7.png";